module.exports = __webpack_public_path__ + "static/media/Screenshot_4-thumb.5c2d1783.png";